module.exports = __webpack_public_path__ + "img/brand-3.1eea4372.png";